import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokArticle } from '../../interfaces/StoryblokArticle.interface';
import { StoryblokNode } from '../../interfaces/StoryblokNode.interface';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import Container from '../Utils/Container/Container';
import ArticleCards from './ArticleCards';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { HeadingTypes } from '../Heading/Heading';

export interface ArticleCardsBlokProps extends Blok {
  articles_to_show: StoryblokNode<StoryblokArticle>[];
}

interface ArticleCardsProps {
  blok: ArticleCardsBlokProps;
}

const ArticleCardsBlok: React.FC<ArticleCardsProps> = ({ blok }) => {
  const { articles_to_show } = blok;

  return (
    <Container>
      <div
        className="pb-24 sm:pb-20 2xl:pb-32 pt-20"
        {...storyblokEditable(blok)}
      >
        <ArticleCards
          articles_to_show={articles_to_show}
          articleCardHeadingType={HeadingTypes.h3}
          articleCardHeadingStyleType={HeadingTypes.h4}
        />
      </div>
    </Container>
  );
};

export default memo(withBlokWrapper(ArticleCardsBlok));
